export const DAILY_GOAL_MIN_DEFAULT = 30;
